import { createApp } from "vue";

import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/base.css";
import "./styles/motion.css";
import "./styles/tailwind.css";

import App from "./App.vue";
import router from "./router";
import { initAnalytics, trackPageView } from "./composables/useAnalytics";

// Enables the scroll-reveal starting state. Without JS the page renders
// fully visible instead of blank.
document.documentElement.classList.add("js");

initAnalytics();

const app = createApp(App).use(router);

// Vuetify serves the /payments route alone. Loading it here, on demand, keeps
// its CSS and runtime out of the bundle the landing page ships.
router.beforeEach(async (to) => {
  if (to.name === "payments") {
    const { installVuetify } = await import(
      /* webpackChunkName: "vuetify" */ "./plugins/vuetify"
    );
    installVuetify(app);
  }
});

router.afterEach((to) => {
  trackPageView(to.fullPath);
});

app.mount("#app");
